import { dateToString, stringToDate } from "../utils/date";

export const addToBasket = ({ vehicleId, stationId, price, startDate, endDate }: { vehicleId: number, stationId: string, price: string, startDate: Date, endDate: Date }) => {
  sessionStorage.setItem("vehicleId", vehicleId.toString());
  sessionStorage.setItem("stationId", stationId);
  sessionStorage.setItem("price", price);
  sessionStorage.setItem("startDate", dateToString(startDate));
  sessionStorage.setItem("endDate", dateToString(endDate));
}

export const emptyBasket = () => {
  sessionStorage.removeItem("vehicleId");
  sessionStorage.removeItem("stationId");
  sessionStorage.removeItem("price");
  sessionStorage.removeItem("startDate");
  sessionStorage.removeItem("endDate");
}

export const isBasketFull = () => {
  return !!sessionStorage.getItem("vehicleId") && !!sessionStorage.getItem("stationId") && !!sessionStorage.getItem("price") && !!sessionStorage.getItem("startDate") && !!sessionStorage.getItem("endDate");
}

export const getBasket = () => {
  const vehicleId = sessionStorage.getItem("vehicleId");
  const stationId = sessionStorage.getItem("stationId");
  const price = sessionStorage.getItem("price");
  const startDate = sessionStorage.getItem("startDate");
  const endDate = sessionStorage.getItem("endDate");

  if (vehicleId && stationId && price && startDate && endDate) {
    return {
      vehicleId: parseInt(vehicleId),
      stationId,
      price: parseFloat(price),
      startDate: stringToDate(startDate),
      endDate: stringToDate(endDate)
    }
  }

  return null;
}